import { render } from "./MeritSupplyPolicy.vue?vue&type=template&id=06ff17e8"
import script from "./MeritSupplyPolicy.vue?vue&type=script&lang=js"
export * from "./MeritSupplyPolicy.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/www/releases/20260911022515/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__